export default __webpack_public_path__ + "static/media/dadangky.40599f29.png";